module.exports = __webpack_public_path__ + "media/images/pathway_illustrations/subject-finance-icon-c395f87126998924d7b03db10fedd188.svg";